import { Box, Stack, styled, Typography } from "@mui/material";
import React from "react";
import Gene20Box from "../../Gene20Box/Gene20Box";

const Gene20BorderBox = styled(Box)`
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  padding: 0.5rem;
  margin: 0.5rem;
`;
export default function Addresses() {
  const JohasnesburgAdd = () => {
    return (
      <Gene20Box align="left">
        <Typography
          variant="body1"
          sx={{
            textTransform: "uppercase",
            fontWeight: (theme) => theme.typography.fontWeightBold,
          }}
        >
          Johannesburg
        </Typography>
        <Stack>
          <Typography
            variant="title"
            sx={{ fontWeight: (theme) => theme.typography.fontWeightLight }}
          >
            61 2nd Avenue <br />
            Bezuidenhout Valley
            <br />
            2094 JHB
            <br />
            Capetown
          </Typography>
        </Stack>
      </Gene20Box>
    );
  };
  const CapeTownAdd = () => {
    return (
      <Gene20Box align="right">
        <Typography
          variant="body1"
          align="right"
          sx={{
            textTransform: "uppercase",
            fontWeight: (theme) => theme.typography.fontWeightBold,
          }}
        >
          Western Cape
        </Typography>
        <Stack>
          <Typography
            variant="title"
            sx={{ align: { xs: "right", sm: "left" } }}
          >
            35119 Harare Hamba Street
            <br />
            Khayelisha
            <br />
            7784
            <br />
            Western Cape
          </Typography>
        </Stack>
      </Gene20Box>
    );
  };
  return (
    <Box>
      <Typography color="primary" sx={{ textTransform: "uppercase" }}>
        visit us
      </Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        sx={{ fontSize: (theme) => theme.typography.size.sm }}
        // px={1.5}
        marginTop="3"
      >
        <Gene20BorderBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box mr={{sm:"5vw"}}>
            <JohasnesburgAdd />
          </Box>
          <CapeTownAdd />
        </Gene20BorderBox>
      </Box>
    </Box>
  );
}
